module.exports = __webpack_public_path__ + "static/img/wx.b8d3c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx.png
// module id = qSza
// module chunks = 1